module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatter"
  }, [_c('div', {
    staticClass: "titlePage",
    attrs: {
      "id": "tp"
    }
  }, [_c('h2', {
    staticClass: "titlePageTitle"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Pink Panther"), _c('sup', [_vm._v("™")])])]), _vm._v(" "), _c('h3', {
    staticClass: "titlePageAuthor"
  }, [_vm._v("A Novelization By Max Allan Collinsbased On The Screenplay By Len Blum And Steve Martin And The Story By Len Blum And Michael Saltzman")]), _vm._v(" "), _c('p', {
    staticClass: "titleimage"
  }, [_c('img', {
    attrs: {
      "alt": "logo",
      "src": "logo.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "dedicationPage",
    attrs: {
      "id": "dp"
    }
  }, [_c('p', {
    staticClass: "dedicationText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Respectfully dedicated to")])]), _vm._v(" "), _c('p', {
    staticClass: "dedicationText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Blake Edwards—"), _c('br'), _vm._v("father of")]), _c('br'), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Peter Gunn,")]), _c('br'), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Professor Fate,"), _c('br'), _vm._v(" and")]), _c('br'), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jacques Clouseau")])])]), _vm._v(" "), _c('div', {
    staticClass: "contents",
    attrs: {
      "id": "con"
    }
  }, [_c('h2', {
    staticClass: "contentsHead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "epi_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_c('a', {
    attrs: {
      "href": "#/epigraph#epi"
    }
  }, [_vm._v("EPIGRAPH")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#ch01"
    }
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ONE")])]), _vm._v("     F"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ATAL")]), _vm._v(" F"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("LAW")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_02"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter02#ch02"
    }
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("TWO")])]), _vm._v("     T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ASE OF THE")]), _vm._v("  M"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ISSING")]), _vm._v(" H"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("OT")]), _vm._v(" D"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("OGS")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_03"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("THREE")])]), _vm._v("     E"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("NTER")]), _vm._v(" I"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("NSPECTOR")]), _vm._v("  C"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("LOUSEAU")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_04"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("FOUR")])]), _vm._v("     M"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("AN OF THE")]), _vm._v("  H"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("OUR")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_05"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("FIVE")])]), _vm._v("     T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("HE")]), _vm._v(" P"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ERFECT")]), _vm._v("  S"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("USPECT")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_06"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("SIX")])]), _vm._v("     P"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("RACTICE FOR")]), _vm._v("  M"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("URDER")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_07"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("SEVEN")])]), _vm._v("     A S"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("USPECT")]), _vm._v("  E"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("LIMINATED")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_08"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("EIGHT")])]), _vm._v("     L"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ICENSE TO")]), _vm._v("  S"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("PILL")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_09"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("NINE")])]), _vm._v("     A"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("N")]), _vm._v(" A"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("VERAGE")]), _vm._v("  F"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("RENCHMAN")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_10"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("TEN")])]), _vm._v("    M"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ANHATTAN")]), _vm._v("  M"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ALADY")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_11"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ELEVEN")])]), _vm._v("     C"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("AUSE FOR")]), _vm._v("  A"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("LARM")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_12"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("TWELVE")])]), _vm._v("     H"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ERO")]), _vm._v("’"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("S")]), _vm._v("  H"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("OMECOMING")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_13"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("THIRTEEN")])]), _vm._v("     R"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ETURN OF THE")]), _vm._v("  P"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("INK")]), _vm._v(" P"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ANTHER")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_14"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("FOURTEEN")])]), _vm._v("      M"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("EDAL OF")]), _vm._v("  H"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ONOR")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "cpy_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/copyright#cpy01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("COPYRIGHT")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "abp_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/aboutthepublisher#abp01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ABOUT THE PUBLISHER")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d343a5b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pinkpantherthe.vue
// module id = 60
// module chunks = 0